import GATSBY_COMPILED_MDX from "/builds/C7NHaypo6/0/fibery/blog/content/blog/startup-diary/chronicles-43/index.md";
import _ from "lodash";
import React, {useState} from "react";
import {graphql, Script} from "gatsby";
import {MDXProvider} from "@mdx-js/react";
import PostHeader from "../components/PostHeader/PostHeader";
import Subscribe from "../components/subscribe";
import SignUpInText from "../components/SignUpInText/SignUpInText";
import RelatedPosts from "../components/RelatedPosts/RelatedPosts";
import PageLayout from "../components/PageLayout/PageLayout";
import Seo from "../components/Seo/Seo";
import PostFooter from "../components/PostFooter/PostFooter";
import ContentWrap from "../components/ContentWrap/ContentWrap";
import BasicContent from "../components/BasicContent/BasicContent";
import TableOfContents from "../components/TableOfContents/TableOfContents";
import ScrollButtons from "../components/ScrollButtons/ScrollButtons";
import TableOfContentsSidebar from "../components/TableOfContentsSidebar/TableOfContentsSidebar";
import CallToAction from "../components/CallToAction/CallToAction";
import ImageCarousel from "../components/ImageCarousel/ImageCarousel";
import PromoCTAPopup from "../components/PromoCTAPopup/PromoCTAPopup";
const shortcodes = {
  SignUpInText,
  Subscribe,
  ImageCarousel
};
const BlogPostTemplate = props => {
  const {readingTime, categories, slug} = props.pageContext;
  const post = props.data.mdx;
  const siteTitle = props.data.site.siteMetadata.title;
  const info = post.frontmatter;
  const featuredImgFluid = info.featuredImage ? info.featuredImage.childImageSharp.gatsbyImageData : null;
  const socialImgFluid = info.socialImage ? info.socialImage.childImageSharp.gatsbyImageData : featuredImgFluid;
  const avatar = props.data.avatar.childImageSharp.gatsbyImageData.images.fallback.src;
  const tags = post.frontmatter.tags;
  const tableOfContents = post.tableOfContents;
  const relatedPosts = props.data.allMdx.edges.filter(({node}) => node.fields.slug !== slug && !node.frontmatter.purpose.includes(3) && !node.frontmatter.purpose.includes(4) && _.intersection(node.frontmatter.tags, tags).length > 0);
  const [userClosedPopup, setUserClosedPopup] = useState(false);
  const handleUserClosedChange = closed => {
    setUserClosedPopup(closed);
  };
  return React.createElement(PageLayout, {
    location: props.location,
    title: siteTitle,
    categories: categories,
    maxWidth: true,
    pageType: userClosedPopup ? "blog-post-page-cta-show" : "blog-post-page"
  }, React.createElement(Seo, {
    titlePage: info.seoTitle || info.title,
    noindex: post.frontmatter.purpose.includes(4),
    description: info.seoDescription || info.description || post.excerpt,
    imagePage: socialImgFluid ? socialImgFluid.images.fallback.src : null,
    isBlogPost: true,
    slug: slug
  }), post.frontmatter.faq && React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: post.frontmatter.faq.map(f => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: f.answer
          }
        }))
      })
    }
  }), info.author && React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        author: {
          "@type": "Person",
          name: info.author
        },
        headline: info.title,
        datePublished: post.frontmatter.date
      })
    }
  }), React.createElement(TableOfContentsSidebar, {
    data: tableOfContents
  }), React.createElement(ContentWrap, null, React.createElement(PostHeader, {
    info: info,
    readingTime: readingTime,
    featuredImage: featuredImgFluid,
    avatar: avatar
  }), React.createElement(ContentWrap, {
    width: "thin"
  }, React.createElement(TableOfContents, {
    data: tableOfContents,
    inPostView: true
  }), React.createElement(BasicContent, null, React.createElement(MDXProvider, {
    components: shortcodes
  }, props.children)))), React.createElement(ContentWrap, {
    withMb: true
  }, React.createElement(PostFooter, {
    info: info,
    readingTime: readingTime,
    avatar: avatar
  })), React.createElement(ContentWrap, {
    withMb: true
  }, React.createElement(CallToAction)), props.pageContext.category !== "Product Management" && React.createElement(RelatedPosts, {
    posts: relatedPosts.slice(0, 4)
  }), React.createElement(ScrollButtons), props.pageContext.category === "Product Management" && React.createElement(PromoCTAPopup), process.env.GATSBY_IFRAMELY_KEY ? React.createElement(Script, {
    async: true,
    src: `https://cdn.iframe.ly/embed.js?api_key=${process.env.GATSBY_IFRAMELY_KEY}&iframe=1&align=left&lazy=1`
  }) : null);
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!, $avatar: String!) {
    avatar: file(absolutePath: { regex: $avatar }) {
      childImageSharp {
        gatsbyImageData(width: 120, height: 120, layout: FIXED)
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        author
        authorTitle
        description
        category
        tags
        purpose
        featuredImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        seoTitle
        seoDescription
        faq {
          question
          answer
        }
      }
      tableOfContents
    }
    allMdx(
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { purpose: { ne: 4 } } }
    ) {
      edges {
        node {
          fields {
            tagSlugs
            slug
            readingTime {
              text
            }
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            category
            tags
            purpose
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 1000, height: 520, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;
